
export const trends = [
    { "id": "0", "value": "None" },
    { "id": "1", "value": "Tăng" },
    { "id": "2", "value": "Giảm" },
    { "id": "3", "value": "Đi ngang" }
]